import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import {
  Ca_State_prov,
  Us_State_prov,
  transformIntoApiCallObj,
} from 'src/app/gdo/gdo-shared/Models/Constants';
import { StatusDTO } from 'src/app/gdo/gdo-shared/Models/Models';
import { GdoStepCompletionStatusComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-step-completion-status/gdo-step-completion-status.component';

@Component({
    selector: 'app-gdo-subscription-contact-information',
    templateUrl: './gdo-subscription-contact-information.component.html',
    styleUrls: ['./gdo-subscription-contact-information.component.scss'],
    standalone: false
})
export class GdoSubscriptionContactInformationComponent implements OnInit {
  @Input() type!: string;
  @Input() subsForm!: UntypedFormGroup;
  isWebView: boolean = false;
  isAcura: boolean = false;

  phoneTypes = [{ value: 'Mobile' }, { value: 'Landline' }];
  preferredLanguage = [
    { displayValue: 'English', value: 'System_US_English_locale' },
    { displayValue: 'French', value: 'fr_CAN' },
  ];
  countries = [
    { displayValue: 'United States', value: 'US' },
    { displayValue: 'Canada', value: 'CA' },
  ];

  stateProvDropdown: any;

  constructor(private router: Router, private appService: AppService, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.onCountryChange(null);

    if (this.appService.getWebviewCurrentStatus()) {
      this.isWebView = true;
    } else {
      this.isWebView = false;
    }

    this.setIsAcuraLocally();
  }

  setIsAcuraLocally() {
    let vehicleData = sessionState.getItem('vehicleMake');
    if (vehicleData) {
      vehicleData = vehicleData.toLowerCase();
      if (vehicleData == 'acura') {
        this.isAcura = true;
      }
    }
  }

  onCountryChange(event: any) {
    const selectedCountry =
      this.subsForm.get('contactDetails')?.value?.country_cd;
    if (selectedCountry && selectedCountry === 'US') {
      this.stateProvDropdown = Us_State_prov;
    } else if (selectedCountry && selectedCountry === 'CA') {
      this.stateProvDropdown = Ca_State_prov;
    }

    // else {
    //     this.stateProvDropdown = [];
    // }
  }
  contactInfoSubmitted() {
    const contactDetails = this.subsForm.get('contactDetails');
    const firstName = contactDetails?.get('first_name');
    const addressLine1 = contactDetails?.get('addressLine1');
    firstName?.markAsTouched();
    firstName?.updateValueAndValidity();
    addressLine1?.markAsTouched();
    addressLine1?.updateValueAndValidity();

    this.updateContactDetails();
  }

  updateContactDetails() {
    let reqObj;
    const acctDetails = this.appService.getAccDetails();
    let billing_group_no =
      acctDetails.billingGroupsInfo && acctDetails.billingGroupsInfo.length > 0
        ? acctDetails.billingGroupsInfo[0].billingGroupNo
        : null;
    let bill_contact_no =
      acctDetails.paymentMethodsInfo &&
      acctDetails.paymentMethodsInfo.length > 0
        ? acctDetails.paymentMethodsInfo[0].billContactNo
        : null;
    let contacts_list = [];
    let composeObject: any;

    const contactDetails = this.subsForm.get('contactDetails');
    if (!contactDetails) return;
    let data = Object.assign(contactDetails.value);
    // data.phone = this.convertToNumericDigits(data.phone);
    // data.cell_phone = this.convertToNumericDigits(data.cell_phone);
    // data.address1 = this.tildeConversion(data.addressLine1);
    // data.address2 = this.tildeConversion(data.address2);
    // data.city = this.tildeConversion(data.city);
    // data.companyName = this.tildeConversion(data.companyName);
    const isDiff = this.findDifference(data, acctDetails);
    if (isDiff) {
      let contacts_list_obj: any = {
        addr_contact_idx: 1,
        addr_first_name: data.first_name,
        addr_last_name: data.last_name,
        addr_phone: data.phone,
        addr_cell_phone: data.cell_phone,
        addr_address1: data.addressLine1,
        addr_address2: data.addressLine2,
        addr_city: data.city,
        addr_country: data.country_cd,
        addr_state_prov: data.state_prov,
        addr_email: acctDetails.email,
        addr_postal_cd: data.postal_cd,
        addr_company_name: data.businessName,
      };
      composeObject = {
        locale_name: data.locale_name,
        acct_contact_idx: 1,
        billing_groups_array: [
          {
            stmt_contact_idx: 1, //hardcode as discussed with wajid
            billing_group_no,
          },
        ],
        // payment_methods_array: [{
        //   bill_contact_idx: 1,//hardcode as discussed with wajid
        //   // bill_contact_no: bill_contact_no,
        //   "payment_method_no": 1, // need to ask honda to include it
        // }],
        contacts_list: [contacts_list_obj],
      };
      reqObj = transformIntoApiCallObj(composeObject, 'update_acct_complete_m');
      
      this.appService.AriaPassThroughConnect(reqObj).subscribe((res) => {
        if (res && res.error_msg === 'OK' && res.error_code === 0) {
          // CPSCFI23M-1805 we don't need to show success pop up
          // this.updateAcc();
          // let statusData: StatusDTO = {
          //   title: 'Contact Information Updated',
          //   details: '',
          //   stepSuccessful: true,
          // };
          // let ref = this.dialog.open(StepCompletionStatusComponent, {
          //   data: statusData,
          // });
        } else {
          let statusData: StatusDTO = {
            title: 'Error occured',
            details: res.error_msg,
            stepSuccessful: false,
          };

          let ref = this.dialog.open(GdoStepCompletionStatusComponent, {
            data: statusData,
          });
        }
      });
    }
  }
  findDifference(submittedData: any, previousData: any) {
    let foundChange: boolean = false;
    if (submittedData.first_name !== previousData.firstName) {
      foundChange = true;
    }
    if (submittedData.last_name !== previousData.lastName) {
      foundChange = true;
    }
    if (submittedData.phone !== previousData.phone) {
      foundChange = true;
    }
    if (submittedData.cell_phone !== previousData.cellPhone) {
      foundChange = true;
    }
    if (submittedData.addressLine1 !== previousData.address1) {
      foundChange = true;
    }
    if (submittedData.addressLine2 !== previousData.address2) {
      foundChange = true;
    }
    if (submittedData.city !== previousData.city) {
      foundChange = true;
    }
    if (submittedData.country_cd !== previousData.countryCode) {
      foundChange = true;
    }
    if (submittedData.state_prov !== previousData.stateProv) {
      foundChange = true;
    }
    if (submittedData.postal_cd !== previousData.postalCode) {
      foundChange = true;
    }
    if (submittedData.businessName !== previousData.companyName) {
      foundChange = true;
    }
    return foundChange;
  }

  tildeConversion(value: string) {
    // if (value && value.length > 0) {
    //   return value;
    // } else return '~';
    return value;
  }
  convertToNumericDigits(phone: string): any {
    // if (phone && phone.length > 0) {
    //   phone = phone.replace(/[() -]/g, "");
    //   return phone;
    // }
    // else {
    //   return '~';
    // }
    return phone;
  }


  onCancel() {
    sessionState.setItem('planType', 'notearlybird');
    if (this.type) {
      this.router.navigate(['/gdoWV'], { replaceUrl: true });
    } else {
      this.router.navigate(['/gdo-product'], { replaceUrl: true });
    }
  }
 

  trackByNgForItem(index: number, item: any): string | number {
    return item?.value ?? item?.payment_method_no ?? item?.paymentMethodNo ?? item?.couponCode ?? item?.id ?? item?.title ?? item?.displayValue ?? item ?? index;
  }
}
